<template>
  <div class="header">
    <div class="header-left">
        <img class="logo" src="https://dw2.s3.ap-southeast-2.amazonaws.com/images/tradedepot/tradedepot-helpcenter-logo.png">
    </div>
  </div>
</template>

<script>
// import { NButton} from "naive-ui";
export default {
  name: "Header",
  components:{
     // NButton
  }
}
</script>

<style scoped>

::placeholder {
  color: white;
  opacity: 1;
}

.header{
  /* display: flex; 
  align-items: center; */
  width:100%;
  background-color: #1E1EAA
}
.header-left{
  /* width:318px;
  display: flex;
  align-items: center; */
  padding: 20px 0px;
  width: 80%;
  margin: auto;
}
.search-input{
  color: white;
  width: 40%;
  background-color: rgba(255,255,255,.15);
  height: 30px;
  border:1px solid white;
}
.header-right{
  flex-grow:2;
  text-align: center
}

.logo{
  position: relative;
  z-index: 1;
  height: 60px;
}
.slogan{
  color: #fff;
  font-weight: 700;
  margin:0;
  position: relative;
  z-index: 1; 
  font-size: 12px
}

@media only screen and (max-width: 1440px) {
  body {
  }
  .header-left{
    width:90%;
  }
}


@media only screen and (max-width: 768px) {
  body {
    background-color: #fffffd;
  }
  .header-left{
    width:90%;
  }
}

@media only screen and (max-width: 600px) {
  
  .logo{
    height: 50px;
  }  
  .slogan{
    color: #fff;
    font-size: 8px;
    font-weight: 700;
    margin:0;
    position: relative;
    z-index: 1; 
  }
  .header-left{
    /* padding: 10px 20px; */
    /* width: 100%; */
  }
}
</style>